import waner from '/public/images/cases/waner.webp'
import geize from '/public/images/cases/geize.webp'
import gabrielaMelo from '/public/images/cases/gabriela-melo.webp'
import adna from '/public/images/cases/adna-carly.webp'
import cinthya from '/public/images/cases/cinthya.webp'
import bruno from '/public/images/cases/bruno.webp'
import amanda from '/public/images/cases/amanda.webp'
import camila from '/public/images/cases/camila.webp'

export const CASES = {
  cinthya: {
    path: cinthya,
    name: 'Cinthya Marquim',
    instagram: '@cinthyamarquim',
    age: '37 anos',
    trainingTime: '2 anos de Foguete'
  },
  gabrielaMelo: {
    path: gabrielaMelo,
    name: 'Gabriela de Melo',
    instagram: '@gdemelo',
    age: '31 anos',
    trainingTime: '1 ano de Foguete',
    weight: '-10kg'
  },
  bruno: {
    path: bruno,
    name: 'Bruno Peterle',
    instagram: '@bruno_bhering1',
    age: '28 anos',
    trainingTime: '7 meses de Foguete',
    weight: '-3kg'
  },
  amanda: {
    path: amanda,
    name: 'Amanda Farias',
    instagram: '@amandafarias_ugc',
    age: '26 anos',
    trainingTime: '6 meses de Foguete',
    weight: '-10kg'
  },
  waner: {
    path: waner,
    name: 'Waner Silveira',
    instagram: '@4pernas8patas',
    age: '58 anos',
    trainingTime: '1 ano de Foguete',
    weight: '-20kg'
  },
  adna: {
    path: adna,
    name: 'Adna Carly',
    instagram: '@adnacarly',
    age: '32 anos',
    trainingTime: '9 meses de Foguete',
    weight: '-10kg'
  },
  camila: {
    path: camila,
    name: 'Camila Prais ',
    instagram: '@cahfilomena',
    age: '26 anos',
    trainingTime: '1 ano de Foguete',
    weight: '-22,5kg'
  },
  geize: {
    path: geize,
    name: 'Geize Gabrielle',
    instagram: '@geizegabrielle',
    age: '26 anos',
    trainingTime: '8 meses de Foguete',
    weight: '-11kg'
  }
}
